<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div>
        <div style="display: none;">
            <div class="figure">
                <div class="wrap">
                    <div class="title">Founder</div>
                    <div class="person-content">
                        <div class="img">
                            <img
                                :src="
                                    this.memberFounder.length > 0
                                        ? this.memberFounder[0].pic_fullpath
                                        : ''
                                "
                                alt=""
                            />
                        </div>
                        <div class="right-content">
                            <!-- <div class="small-title">
                                <span class="sub-title">{{
                                    this.memberFounder.length>0?this.memberFounder[0].name:''
                                }}</span>
                                <span class="ceo">{{
                                    this.memberFounder.length>0?this.memberFounder[0].job:''
                                }}</span>
                            </div> -->
                            <div class="Description-sl">
                                <div v-html="Description"></div>
                            </div>
                            <!-- <div class="down">
                                    <img src="@/assets/about/down.png" alt="" />
                                </div> -->
                            <!-- <div
                                class="down"
                                v-if="!isShowAll && isRoll"
                                @click="toDown"
                            >
                                <i class="el-icon-arrow-down"></i>
                            </div>
                            <div
                                class="down"
                                v-if="!isShowAll && !isRoll"
                                @click="toUp"
                            >
                                <i class="el-icon-arrow-up"></i>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-content">
                <div class="wrap">
                    <div class="title">MANAGEMENT TEAM</div>
                </div>
                <div class="management">
                    <ul>
                        <li
                            v-for="(item, index) in memberManagement"
                            :key="index"
                        >
                            <div class="img">
                                <img :src="item.pic_fullpath" alt="" />
                            </div>
                            <div class="name">
                                <div class="sub-name">{{ item.name }}</div>
                                <div class="doc">{{ item.job }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="main-content hl">
                <div class="wrap">
                    <div class="title">INDEPENDENT DIRECTOR</div>
                </div>
                <div class="management">
                    <ul>
                        <li
                            v-for="(item, index) in memberDircetor"
                            :key="index"
                        >
                            <div class="img">
                                <img :src="item.pic_fullpath" alt="" />
                            </div>
                            <div class="name">
                                <div class="sub-name">{{ item.name }}</div>
                                <div class="doc">{{ item.job }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="main-content hl">
                <div class="wrap">
                    <div class="title">POTENTIAL ADVISOR</div>
                </div>
                <div class="management">
                    <ul>
                        <li v-for="(item, index) in memberAdvisor" :key="index">
                            <div class="img">
                                <img :src="item.pic_fullpath" alt="" />
                            </div>
                            <div class="name">
                                <div class="sub-name">{{ item.name }}</div>
                                <div class="doc">{{ item.job }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div>
            <div class="Content-body"  style="display: none;">
                <div class="StrangLine">
                    <div class="StrangLineItem">GENERAL CONTACT</div>
                    <div class="StrangLineItem">BUSNIESS</div>
                    <div class="StrangLineItem">INVESTOR RELATIONS</div>
                    <div class="clear"></div>
                </div>
                <div class="LowLine">
                    <div class="LowLineItem">hello@multi-metaverse.com</div>
                    <div class="LowLineItem">business@multi-metaverse.com</div>
                    <div class="LowLineItem">ir@multi-metaverse.com</div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <div class="Contact-page">
            <div class="Contact-Main">
                <div class="ContactTitle">CONTACT</div>
                <div>
                    <div class="contactItem-left">
                        <div class="itemText ">
                            General
                            <br/>
                            hello@multi-metaverse.com
                        </div>
                    </div>
                    <div class="contactItem-right">
                        <div class="itemText">
                            Business
                            <br/>
                            business@multi-metaverse.com
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="Contact-Main">
                <div class="ContactTitle">INVESTOR RELATIONS CHINA</div>
                <div>
                    <div class="contactItem-left ">
                        <div class="itemText">
                            MultiMetaVerse Inc.
                            <br/>
                            ir@multi-metaverse.com
                        </div>
                    </div>
                    <!-- <div class="contactItem-right">
                        <div class="itemText">
                            The Piacente Group, Inc.
                            <br/>
                            Jenny Cai
                            <br/>
                            Tel: +86-10-6508-0677
                            <br/>
                            Email:MultiMetaVerse@thepiacentegroup.com
                        </div>
                    </div> -->
                    <div class="clear"></div>
                </div>
            </div>
            <!-- <div class="Contact-Main">
                <div class="ContactTitle">INVESTOR RELATIONS US</div>
                <div>
                    <div class="contactItem-midd">
                        <div class="itemText">
                            The Piacente Group, Inc.
                            <br/>
                            Brandi Piacente
                            <br/>
                            Tel: +1-212-481-2050
                            <br/>
                            E-mail: MultiMetaVerse@thepiacentegroup.co
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div> -->
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "News",
    components: { footerBox, navBox, mapBox },
    data() {
        return {
            memberManagement: [],
            memberDircetor: [],
            memberAdvisor: [],
            memberFounder: [],
            bannerHead: [],
            types: "",
            fullpathImg: "",
            pathUrl: "",
            loading: false,
            isShowAll: true,
            isRoll: true,
            Description: null,
        };
    },
    watch: {
        // memberFounder: function (newName) {
        //     if (newName[0].explain.length > 1400) {
        //         this.Description =
        //             newName[0].explain.substring(0, 1400) + "...";
        //         this.isShowAll = false;
        //     } else {
        //         this.Description = newName[0].explain;
        //         this.isShowAll = true;
        //     }
        // },
    },
    created() {
        this.loading = true;
        this.$http.getWebAbout().then((res) => {
            this.memberManagement = res.config["Business-member-management"];
            this.memberDircetor = res.config["Business-member-dircetor"];
            this.memberAdvisor = res.config["Business-member-advisor"];

            this.memberFounder = res.config["Business-member-founder"];
            this.Description = res.config["Business-member-founder"][0].explain;//加滚动条

            this.bannerHead = res.config["Banner-banner-head"];
            this.types = this.bannerHead[0].types;
            this.fullpathImg = this.bannerHead[0].pic_fullpath;
            this.pathUrl = this.bannerHead[0].links;
            this.loading = false;
        });
    },
    methods: {
        // 点击按钮展开
        toDown() {
            this.Description = this.memberFounder[0].explain;
            this.isRoll = false;
        },
        // 点击按钮收起
        toUp() {
            this.Description =
                this.memberFounder[0].explain.slice(0, 1400) + "...";
            this.isRoll = true;
        },
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.figure {
    background: url("../../assets/about/content-bg.png");
    height: 630px;
    .title {
        background: url("../../assets/about/navBox.png");
        height: 49px;
        line-height: 49px;
        margin: 45px 0;
        text-indent: 60px;
        color: #ffffff;
        font-weight: bold;
        font-size: 24px;
    }
    .person-content {
        display: flex;
        .img {
            background: #ffffff;
            img {
                width: 396px;
                height: 426px;
            }
        }
    }
    .right-content {
        background: #f2f2f2;
        padding: 30px;
        font-family: "Lucida Bright";
        width: 100%;
        .Description-sl {
            height: 365px;
            overflow: auto;
            font-size: 14px;
        }
        // .Description-sl::-webkit-scrollbar {
        //     width: 6px;
        //     height: 6px;
        // }
        // /*定义滚动条轨道 内阴影+圆角*/
        // .Description-sl::-webkit-scrollbar-track {
        //     border-radius: 10px;
        //     background-color: rgba(92, 92, 92, 0.5);
        // }
        // /*定义滑块 内阴影+圆角*/
        // .Description-sl::-webkit-scrollbar-thumb {
        //     border-radius: 10px;
        //     background-color: rgba(240, 240, 240, 0.5);
        // }
        // .small-title {
        /deep/.name {
            font-size: 26px;
            color: #283254;
            margin-right: 30px;
        }
        /deep/.ceo {
            font-size: 14px;
            color: #888888;
            // margin-left: 20px;
        }
        // }
        /deep/ul > li {
            margin-top: 20px;
            font-size: 14px;
        }
        .down {
            text-align: center;
            margin-top: 25px;
            cursor: pointer;
        }
    }
}
.main-content {
    .title {
        background: url("../../assets/about/navBox.png") no-repeat;
        height: 49px;
        line-height: 49px;
        margin: 0 0 30px 0;
        text-indent: 60px;
        color: #ffffff;
        font-weight: bold;
        font-size: 24px;
    }
    .management {
        width: 1230px;
        margin: 0 auto;
        margin-bottom: 50px;
        ul > li {
            width: 275px;
            height: 360px;
            display: inline-block;
            margin: 0 15px 55px 17px;
            vertical-align: top;
            .img {
                img {
                    width: 275px;
                    height: 275px;
                }
            }
            .name {
                width: 275px;
                height: 90px;
                text-align: center;
                background: #f2f2f2;
                .sub-name {
                    font-size: 26px;
                    color: #283254;
                    padding-top: 15px;
                }
                .doc {
                    padding-top: 10px;
                    font-size: 14px;
                    color: #888888;
                }
            }
        }
    }
}
.main-content .management ul > li:hover {
    cursor: pointer;
    filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
    -moz-box-shadow: 2px 2px 10px #909090;
    -webkit-box-shadow: 2px 2px 10px #909090;
    box-shadow: 2px 2px 10px #909090;
}
.main-content .management ul > li:hover {
    .name {
        background: #283254;
    }
    .sub-name {
        color: #ffffff;
    }
}
.hl {
    margin-top: 60px;
}
/deep/.sp-bl {
    display: flex;
    line-height: 20px;
    .rl {
        margin-right: 10px;
    }
}
.Content-body{
    width: 80%; height: 120px; text-align: center; margin: auto; margin-top: 100px;
    .StrangLine {
        width: 100%;height: 60px; text-align: center; background-color: #000000;;
        .StrangLineItem {
            width:33%; 
            height:100%; 
            float:left; 
            margin: 0 auto;
            text-align: center;
            font-size:22px; 
            font-weight: bold;
            line-height:60px;
            color: #FFFFFF;
        }
    }
    .LowLine {
        width: 100%;height: 60px; text-align: center;
        .LowLineItem {
            width:33%; 
            height:100%; 
            float:left; 
            margin: 0 auto;
            text-align: center;
            font-size:16px; 
            line-height:60px;
        }
    }
}
.clear {
    clear: both;
}


.Contact-page {
    margin: 40px;
}
.Contact-Main {
    width: 70%;
    height: auto;
    text-align: center;
    margin: auto;
    margin-bottom: 10px;
}
.ContactTitle {
    height:50px;
    font-size: 30px;
    font-weight: bold;
    line-height: 50px;
    color: #FFFFFF;
    background-color: #000000;
}
.contactItem-left {
    width: 25%;
    height: auto;
    text-align: left;
    margin-left: 20%;
    float: left;
}
.contactItem-right {
    width: 25%;
    height: auto;
    text-align: left;
    margin-right: 20%;
    float: right;
}
.itemText {
    padding: 16px 10px 10px 10px;
    font-size: 18px;
    line-height: 24px;
}
.contactItem-midd {
    width: 33.3%;
    height: auto;
    text-align: center;
    margin-left: 33.3%;
}
</style>